import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isOpen: false,
  contentId: null,
};

const supportDrawerSlice = createSlice({
  name: 'supportDrawer',
  initialState,
  reducers: {
    open(state, { payload: { contentId } }) {
      state.isOpen = true;
      state.contentId = contentId;
    },
    close(state) {
      state.isOpen = false;
    },
  },
});

export const {
  open,
  close,
} = supportDrawerSlice.actions;
export default supportDrawerSlice.reducer;
